/**
 * Yorug' / qorong'i mavzu.
 *
 * Uch holat: `system` (tizim sozlamasiga ergashadi), `light`, `dark`.
 * Tanlov brauzerda saqlanadi va sahifa chizilishidan OLDIN qo'llanadi —
 * aks holda ochilishda oq lipillash ko'rinadi.
 */

export const THEMES = ['system', 'light', 'dark'] as const;
export type Theme = (typeof THEMES)[number];

const STORAGE_KEY = 'asko.theme';

export function readTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  return (THEMES as readonly string[]).includes(stored ?? '') ? (stored as Theme) : 'system';
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  // `system` da belgi qo'yilmaydi: CSS o'zi `prefers-color-scheme` ga
  // qaraydi. Belgi faqat odam ataylab tanlaganda paydo bo'ladi.
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
}

export function saveTheme(theme: Theme): void {
  localStorage.setItem(STORAGE_KEY, theme);
  applyTheme(theme);
}
